import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../ApiHelper"
import Layout from "./Layout"
import { LoadModalWithLabel } from "./modais"
import { InputCustom } from "../components"
import { confirmAlert } from "react-confirm-alert"
class ImportacaoTCM extends Component {
  constructor() {
    super()
    this.onChangeAno = this.onChangeAno.bind(this)
    this.onChangeCodigoMunicipio = this.onChangeCodigoMunicipio.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.validate = this.validate.bind(this)
    this.sendImportacao = this.sendImportacao.bind(this)
    this.getCpfCNPJ = this.getCpfCNPJ.bind(this)
    this.state = {
      ano: new Date().getFullYear(),
      codigoMunicipio: "",
      codigoMunicipioError: "",
      anoError: "",
      showLoad: false,
      cpfCnpjToImport: [],
      errosContratados: [],
      sucessosContratados: [],
      labelLoading: "",
      showContratadosFinishLabel: "",
      etapas: 0
    }
  }
  getCpfCNPJ() {
    this.setState({
      etapas: 0,
      sucessosContratados: [],
      errosContratados: []
    })
    ApiHelper.getCpfCnpj((data, error) => {
      if (error) {
        this.setState({
          responseError: error
        })
      } else {
        var documentosDosContratados = data
        this.setState({
          etapas: documentosDosContratados.length
        })
        this.setState({
          cpfCnpjToImport: documentosDosContratados,
          errosContratados: []
        })
        this.getNextContratado()
      }
    })
  }
  getNextContratado() {
    var documentos = this.state.cpfCnpjToImport
    var next = documentos.pop()
    var etapaNumber = this.state.etapas - documentos.length

    this.setState({
      labelLoading:
        "Importando itens de contrato e notas fiscais\n etapa " +
        etapaNumber +
        " de " +
        this.state.etapas +
        "\n Aguarde, o processo pode levar muitos minutos"
    })
    if (next) {
      ApiHelper.getNotasForContratado(
        this.state.ano,
        this.state.codigoMunicipio.padStart(3, 0),
        next,
        () => {
          this.getNextContratado()
        }
      )
    } else {
      this.toggleLoadModal()
      this.setState({
        showContratadosFinishLabel: true
      })
    }
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  onChangeCodigoMunicipio(event) {
    var newValue = event.target.value
    this.setState({
      codigoMunicipio: newValue,
      codigoMunicipioError: ""
    })
  }
  onChangeAno(event) {
    var newValue = event.target.value
    this.setState({
      ano: newValue,
      anoError: ""
    })
  }
  sendImportacao(event) {
    event.preventDefault()
    if (this.validate()) {
      confirmAlert({
        title:
          "Ao iniciar a importação todos os dados do banco de dados serão removidos completamente",
        message: "Tem certeza que deseja iniciar?",
        buttons: [
          {
            label: "Sim",
            onClick: () => {
              var ano = this.state.ano
              var codigoMunicipio = this.state.codigoMunicipio
              this.setState({
                errosContratados: [],
                sucessosContratados: [],
                showContratadosFinishLabel: false,
                anoError: "",
                codigoMunicipioError: "",
                responseError: "",
                responseData: ""
              })
              this.setState({
                labelLoading:
                  "Importando contratos, unidades orçamentárias, contratados e gestores\n Aguarde, o processo pode levar muitos minutos"
              })
              this.toggleLoadModal()
              ApiHelper.sendImportacao(
                ano,
                codigoMunicipio.padStart(3, 0),
                (data, error) => {
                  if (error) {
                    this.toggleLoadModal()
                    this.setState({
                      responseError: error
                    })
                  } else {
                    this.setState({
                      responseData: data
                    })
                    this.getCpfCNPJ()
                  }
                }
              )
            }
          },
          {
            label: "Não"
          }
        ]
      })
    }
  }
  validate() {
    var anoError = ""
    var codigoMunicipioError = ""
    if (!this.state.ano) {
      anoError = "Digite o exercício"
    }
    if (!this.state.codigoMunicipio) {
      codigoMunicipioError = "Digite o código do município"
    }
    this.setState({
      codigoMunicipioError: codigoMunicipioError,
      anoError: anoError
    })
    return anoError === "" && codigoMunicipioError === ""
  }
  render() {
    var minYear = 2008
    return (
      <Layout>
        <LoadModalWithLabel
          label={this.state.labelLoading}
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div className="container-fluid">
          <div>
            <div className="card card-plain">
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">Importação TCE</h4>
                <p className="category">
                  Importar dados da API do Tribunal de Contas do Estado do Ceará
                </p>
              </div>
              <div className="card-content">
                <div className="row">
                  <InputCustom
                    error={this.state.codigoMunicipioError}
                    max={179}
                    type="number"
                    onChange={this.onChangeCodigoMunicipio}
                    sizeClass="col-md-2"
                    label="Código do município"
                    value={this.state.codigoMunicipio}
                  />
                  <InputCustom
                    error={this.state.anoError}
                    min={minYear}
                    max={new Date().getFullYear()}
                    sizeClass="col-md-1"
                    type="number"
                    onChange={this.onChangeAno}
                    label="Exercício"
                    value={this.state.ano}
                  />
                </div>
                <div className="row">
                  <button
                    onClick={this.sendImportacao}
                    type="submit"
                    className="btn btn-primary pull-left"
                    data-background-color="as-blue"
                  >
                    Importar
                  </button>
                </div>
              </div>
              {this.state.responseData && (
                <div>
                  <div className="row">
                    <strong style={{ color: "green" }}>
                      {this.state.responseData.unidadeOrcamentaria}
                    </strong>
                  </div>
                  <div className="row">
                    <strong style={{ color: "green" }}>
                      {this.state.responseData.gestores}
                    </strong>
                  </div>
                  <div className="row">
                    <strong style={{ color: "green" }}>
                      {this.state.responseData.contratados}
                    </strong>
                  </div>
                  <div className="row">
                    <strong style={{ color: "green" }}>
                      {this.state.responseData.contratos}
                    </strong>
                  </div>
                </div>
              )}
              {this.state.responseError && (
                <div className="row">
                  <strong style={{ color: "red" }}>
                    Ocorreram erros na importação, entre em contato com a AS
                    Sistemas
                  </strong>
                </div>
              )}
              {this.state.showContratadosFinishLabel && (
                <div>
                  <div className="row">
                    <strong style={{ color: "green" }}>
                      {this.state.sucessosContratados.length +
                        " etapas bem sucedidas"}
                    </strong>
                  </div>
                  {this.state.errosContratados.map(contratado => {
                    return (
                      <div className="row">
                        <strong style={{ color: "green" }}>
                          {"Erro importando dados do fornecedor " + contratado}
                        </strong>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
export default withRouter(ImportacaoTCM)



// WEBPACK FOOTER //
// ./src/views/ImportacaoTCE.js